export const getStoredVersionInfo = () => ({});
export const fetchBuildMeta = async () => ({});
export const performAppUpdate = () => {};
export const setStoredVersionInfo = () => {};
export const checkAndClearAppUpdatedFlag = () => false;
export const clearAllCaches = async () => {};
export default '1.0.0';